import * as React from "react";
import corporateIcon from "@/assets/corporate_icon.png";
import { Link } from "@/component/atoms/link";

export const GrafferAuthButton: React.FC = () => (
  <div className="c-auth-button-skin">
    <Link href={`/login/email${window.location.search}`}>
      <img src={corporateIcon} alt="" />
      <span className="has-text-centered ml-2 is-size-6">
        メールアドレスでログイン
      </span>
    </Link>
  </div>
);
